<template>
  <div class="content-wrapper">
    <PageHeader :title="$t('map.tolldomains.dsrc_instances.title')" />
    <div class="version-panel">
      <VersionPanel
        :instances="getCCCDatInstances(masterAccount)"
        :dats="getCCCDats(masterAccount)"
        :masterAccount="masterAccount"
        instanceType="CCC"
        @updateList="updateList"
      />
    </div>
    <div class="version-panel">
      <VersionPanel
        :instances="getEFCDatInstances(masterAccount)"
        :dats="getEFCDats(masterAccount)"
        :masterAccount="masterAccount"
        instanceType="EFC"
        @updateList="updateList"
      />
    </div>
    <div class="version-panel">
      <VersionPanel
        :instances="getUNIDatInstances(masterAccount)"
        :dats="[]"
        :masterAccount="masterAccount"
        instanceType="UNI"
      />
    </div>
    <div class="version-panel">
      <VersionPanel
        :instances="getLACDatInstances(masterAccount)"
        :dats="getLACDats(masterAccount)"
        :masterAccount="masterAccount"
        instanceType="LAC"
        @updateList="updateList"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { MasterAccountInfo } from 'ctp-user-auth-service';
import { DatV2, InstanceRelated } from 'ctp-toll-domain';
import { store } from '@/store/modules/datInstances/types';
import { store as datStore } from '@/store/modules/dats/types';
import { store as userStore } from '@/store/modules/user/types';
import PageHeader from '@/components/common/PageHeader/PageHeader.vue';
import VersionPanel from './components/VersionPanel.vue';

@Component({
  components: {
    PageHeader,
    VersionPanel
  }
})
export default class DatInstances extends Vue {
  @userStore.Getter
  private getSelectedMasterAccount: MasterAccountInfo;

  @datStore.Action
  private fetchDats!: any;

  @store.Action
  private fetchDatInstances!: any;

  @datStore.Getter
  private getCCCDats: (master: MasterAccountInfo) => DatV2[];

  @datStore.Getter
  private getEFCDats: (master: MasterAccountInfo) => DatV2[];

  @datStore.Getter
  private getLACDats: (master: MasterAccountInfo) => DatV2[];

  @store.Getter
  private getCCCDatInstances: (master: MasterAccountInfo) => InstanceRelated[];

  @store.Getter
  private getEFCDatInstances: (master: MasterAccountInfo) => InstanceRelated[];

  @store.Getter
  private getUNIDatInstances: (master: MasterAccountInfo) => InstanceRelated[];

  @store.Getter
  private getLACDatInstances: (master: MasterAccountInfo) => InstanceRelated[];

  private masterAccount: MasterAccountInfo = {
    id: 0,
    name: '',
    vdoName: '',
    routeId: '',
    dsrcKeysEncryption: false
  };

  private updateList() {
    this.fetchDatInstances(this.masterAccount);
  }

  @Watch('getSelectedMasterAccount', { immediate: true, deep: true })
  private onMasterChange() {
    const account = this.getSelectedMasterAccount;
    if (account.name) {
      this.masterAccount = ({ ...this.masterAccount, ...account });
      Promise.all([this.fetchDatInstances(this.masterAccount), this.fetchDats(this.masterAccount)]);
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles/dat-instances.scss';
</style>
